// Word exposes a paragraph's heading identity through two locale-independent
// signals: styleBuiltIn (the canonical Word.BuiltInStyleName enum, e.g.
// "Heading1") and outlineLevel (a number where 1-9 are heading outline levels
// and 10 is body text). styleBuiltIn returns "Other" for custom/renamed styles,
// so outlineLevel is the fallback that also catches non-standard headings Word
// still treats as outline levels. Neither depends on the localized `style` name.
const HEADING_STYLE = /^Heading[1-9]$/;

const hasHeadingOutlineLevel = (level) =>
  Number.isInteger(level) && level >= 1 && level <= 9;

export const isHeadingItem = (item) =>
  Boolean(item) &&
  (HEADING_STYLE.test(item.styleBuiltIn ?? "") ||
    hasHeadingOutlineLevel(item.outlineLevel));

export const getHeadingLevel = (item) => {
  if (hasHeadingOutlineLevel(item?.outlineLevel)) {
    return item.outlineLevel;
  }
  const [digit] = (item?.styleBuiltIn ?? "").match(/\d+/) || [];
  const level = parseInt(digit, 10);
  return Number.isNaN(level) ? 1 : Math.max(level, 1);
};
